function toBool(value, def) {
  if (value) {
    return value === 'true';
  }
  return def;
}

const serverApi = process.env.VUE_APP_API_SERVER;
const apiKey = process.env.VUE_APP_API_KEY;
const wpApiServer = process.env.VUE_APP_WP_API_SERVER
const gapiKey = process.env.VUE_APP_GAPI_KEY;
const nodeEnv = process.env.NODE_ENV;
const serverEnv = process.env.VUE_APP_SERVER;
let langs = process.env.VUE_APP_ALLOWED_LANG ?? 'en|de';
langs = langs.split('|');
if (!Array.isArray(langs)) {
  langs = [langs];
}

const configEnv = {
  nodeEnv,
  serverEnv,
  serverApi,
  apiKey,
  wpApiServer,
  gapiKey,
  start_year_payout_table_almost_done: process.env.VUE_APP_ALMOST_DONE_SHOW_PAYOUT_TABLE_START_YEAR,
  end_year_payout_table_almost_done: process.env.VUE_APP_ALMOST_DONE_SHOW_PAYOUT_TABLE_END_YEAR,
  enabled_pages: process.env.VUE_APP_ENABLED_PAGES?.split(',').filter((p) => !!p) || [],
  disabled_pages: process.env.VUE_APP_DISABLED_PAGES?.split(',').filter((p) => !!p) || [],
  own_url: process.env.VUE_APP_OWN_URL ?? 'https://wetterheld.com/home',
  show_prices: toBool(process.env.VUE_APP_SHOW_PRICES, true),
  show_policy: toBool(process.env.VUE_APP_SHOW_POLICY, true),
  logo_file: process.env.VUE_APP_LOGO_FILE ?? 'logo.svg',
  login_success_redirect_page: process.env.VUE_APP_LOGIN_SUCCESS_REDIRECT_PAGE ?? 'main',
  logo_redirect_page: process.env.VUE_APP_LOGO_REDIRECT_PAGE ?? '',
  default_language: process.env.VUE_APP_DEFAULT_LANGUAGE ?? 'de',
  default_wp_language: process.env.VUE_APP_DEFAULT_WP_LANGUAGE ?? 'en',
  iban_validation_rule: process.env.VUE_APP_IBAN_VALIDATION_RULE ?? '1',
  prio_partners: process.env.VUE_APP_PRIO_PARTNER_CODES ?? [],
  primary_color: process.env.VUE_APP_COLORS_1 ?? '#E834B1',
  secondary_color: process.env.VUE_APP_COLORS_2 ?? '#03aaf5',
  tertiary_color: process.env.VUE_APP_COLORS_3 ?? '#000000',
  quaternary_color: process.env.VUE_APP_COLORS_4 ?? '#333333',
  quinary_color: process.env.VUE_APP_COLORS_5 ?? '#dddddd',
  senary_color: process.env.VUE_APP_COLORS_6 ?? '#000000',
  septenary_color: process.env.VUE_APP_COLORS_7 ?? '#aaaaaa',
  button_text_color: process.env.VUE_APP_BUTTON_TEXT_COLOR ?? '#FFFFFF',
  button_background_color: process.env.VUE_APP_BUTTON_BACKGROUND_COLOR ?? '#E834B1',
  border_input_color: process.env.VUE_APP_BORDER_INPUT_COLOR ?? '#D8D8D8',
  header_menu: process.env.VUE_APP_HEADER_MENU ?? '/wp-json/menus/v1/menus/front-page-menu',
  insurance_back_disable: toBool(process.env.VUE_APP_INSURANCE_BACK_DISABLE, false),
  show_imprint: toBool(process.env.VUE_APP_SHOW_IMPRINT, false),
  baloise_strings: toBool(process.env.VUE_APP_BALOISE_STRINGS, false),
  allowed_langs: langs,
  allowed_langs_pattern: langs.join('|'),
  disable_registration: process.env.VUE_APP_DISABLE_REGISTRATION ?? false,
  padding_horizontal_input_fields: process.env.VUE_APP_PADDING_HORIZONTAL_INPUT_FIELDS ?? '1.46rem',
  border_radius: process.env.VUE_APP_BORDER_RADIUS ?? '9999px',
  server_type: process.env.VUE_APP_SERVER_VERSION ?? 'Wetterheld',
  insurance_page_name: process.env.VUE_APP_INSURANCE_PAGE_NAME ?? 'insurance',
  search_countries_address: [process.env.VUE_APP_COUNTRY_CODE_SALE] || ['DE'],
  currency_before: process.env.VUE_APP_CURRENCY_BEFORE ?? false,
  payout_request: process.env.VUE_APP_PAYOUT_REQUEST ?? 1,
  show_name_and_phone_personal_settings: toBool(process.env.VUE_APP_SHOW_NAME_AND_PHONE_PERSONAL_SETTINGS, true),
};

export default configEnv;
